import { application } from "./application"

import AdFormController from "./ad_form_controller"
import AvatarPreviewController from "./avatar_preview_controller"
import BusScheduleController from "./bus_schedule_controller"
import CallController from "./call_controller"
import ChatFormController from "./chat_form_controller"
import ChatMessageController from "./chat_message_controller"
import ChipRadioController from "./chip_radio_controller"
import DistrictSelectorController from "./district_selector_controller"
import DistrictSwitcherController from "./district_switcher_controller"
import ChatPageController from "./chat_page_controller"
import ChatWidgetController from "./chat_widget_controller"
import ClipsController from "./clips_controller"
import ClipVideoController from "./clip_video_controller"
import ConfirmDeleteController from "./confirm_delete_controller"
import CookieConsentController from "./cookie_consent_controller"
import ConversationFormController from "./conversation_form_controller"
import CopyIdController from "./copy_id_controller"
import ConversationPageController from "./conversation_page_controller"
import DropdownController from "./dropdown_controller"
import EventFormController from "./event_form_controller"
import FeedbackModalController from "./feedback_modal_controller"
import FeedbackTriggerController from "./feedback_trigger_controller"
import RejectReasonController from "./reject_reason_controller"
import ReportModalController from "./report_modal_controller"
import ReportTriggerController from "./report_trigger_controller"
import AutoCloseController from "./auto_close_controller"
import FeedRefreshController from "./feed_refresh_controller"
import FileDropController from "./file_drop_controller"
import FilePreviewController from "./file_preview_controller"
import FormValidationController from "./form_validation_controller"
import HoursEditorController from "./hours_editor_controller"
import LightboxController from "./lightbox_controller"
import LoadMoreController from "./load_more_controller"
import LoginCtaController from "./login_cta_controller"
import MobileGalleryController from "./mobile_gallery_controller"
import MobileMenuController from "./mobile_menu_controller"
import NavigateController from "./navigate_controller"
import NotificationsController from "./notifications_controller"
import PhoneController from "./phone_controller"
import PhoneMaskController from "./phone_mask_controller"
import PhotoPreviewController from "./photo_preview_controller"
import PostFormController from "./post_form_controller"
import PresenceController from "./presence_controller"
import ProfileTabsController from "./profile_tabs_controller"
import PriceMaskController from "./price_mask_controller"
import ProfileLinkController from "./profile_link_controller"
import PushNotificationsController from "./push_notifications_controller"
import PwaInstallController from "./pwa_install_controller"
import RatingInputController from "./rating_input_controller"
import ReactionController from "./reaction_controller"
import ReplyController from "./reply_controller"
import ReportToggleController from "./report_toggle_controller"
import ReviewCtaController from "./review_cta_controller"
import ReviewFormController from "./review_form_controller"
import SearchClearController from "./search_clear_controller"
import SelectFieldController from "./select_field_controller"
import SingleUploadController from "./single_upload_controller"
import SpoilerController from "./spoiler_controller"
import SubmitLoaderController from "./submit_loader_controller"
import TagScrollController from "./tag_scroll_controller"
import WeatherAccordionController from "./weather_accordion_controller"
import FishingTabsController from "./fishing_tabs_controller"
import YandexMapController from "./yandex_map_controller"
import YandexMapFormController from "./yandex_map_form_controller"
import YandexMapShowController from "./yandex_map_show_controller"

application.register("ad-form", AdFormController)
application.register("avatar-preview", AvatarPreviewController)
application.register("bus-schedule", BusScheduleController)
application.register("call", CallController)
application.register("chat-form", ChatFormController)
application.register("chat-message", ChatMessageController)
application.register("chip-radio", ChipRadioController)
application.register("district-selector", DistrictSelectorController)
application.register("district-switcher", DistrictSwitcherController)
application.register("chat-page", ChatPageController)
application.register("chat-widget", ChatWidgetController)
application.register("clips", ClipsController)
application.register("clip-video", ClipVideoController)
application.register("confirm-delete", ConfirmDeleteController)
application.register("cookie-consent", CookieConsentController)
application.register("conversation-form", ConversationFormController)
application.register("copy-id", CopyIdController)
application.register("conversation-page", ConversationPageController)
application.register("dropdown", DropdownController)
application.register("event-form", EventFormController)
application.register("feedback-modal", FeedbackModalController)
application.register("feedback-trigger", FeedbackTriggerController)
application.register("reject-reason", RejectReasonController)
application.register("report-modal", ReportModalController)
application.register("report-trigger", ReportTriggerController)
application.register("auto-close", AutoCloseController)
application.register("feed-refresh", FeedRefreshController)
application.register("file-drop", FileDropController)
application.register("file-preview", FilePreviewController)
application.register("form-validation", FormValidationController)
application.register("hours-editor", HoursEditorController)
application.register("lightbox", LightboxController)
application.register("load-more", LoadMoreController)
application.register("login-cta", LoginCtaController)
application.register("mobile-gallery", MobileGalleryController)
application.register("mobile-menu", MobileMenuController)
application.register("navigate", NavigateController)
application.register("notifications", NotificationsController)
application.register("phone", PhoneController)
application.register("phone-mask", PhoneMaskController)
application.register("photo-preview", PhotoPreviewController)
application.register("post-form", PostFormController)
application.register("presence", PresenceController)
application.register("profile-tabs", ProfileTabsController)
application.register("price-mask", PriceMaskController)
application.register("profile-link", ProfileLinkController)
application.register("push-notifications", PushNotificationsController)
application.register("pwa-install", PwaInstallController)
application.register("rating-input", RatingInputController)
application.register("reaction", ReactionController)
application.register("reply", ReplyController)
application.register("report-toggle", ReportToggleController)
application.register("review-cta", ReviewCtaController)
application.register("review-form", ReviewFormController)
application.register("search-clear", SearchClearController)
application.register("select-field", SelectFieldController)
application.register("single-upload", SingleUploadController)
application.register("spoiler", SpoilerController)
application.register("submit-loader", SubmitLoaderController)
application.register("tag-scroll", TagScrollController)
application.register("weather-accordion", WeatherAccordionController)
application.register("fishing-tabs", FishingTabsController)
application.register("yandex-map", YandexMapController)
application.register("yandex-map-form", YandexMapFormController)
application.register("yandex-map-show", YandexMapShowController)
